/****
 * Custom hook for accessing the current user's roles and role-based
 * permissions from the application state.
 *
 * Retrieves assigned roles from Redux and exposes role-related
 * utilities used throughout the application for authorization
 * and access control checks.
 */
import { useAppSelector } from "@/store/hooks";

import type { EffectiveRole } from "../auth/types";
import { selectRoles } from "../store/userSlice";

export type RoleContextType = {
  roles: EffectiveRole[];
  setRole: (_r: EffectiveRole) => void;
  setRoles: (_r: EffectiveRole[]) => void;
};

export const useRole = (): RoleContextType => {
  const roles = useAppSelector(selectRoles);

  const setRole = () => {};
  const setRoles = () => {};

  return { roles, setRole, setRoles };
};
